import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TVesselInfo, TVesselDailyPositionsSliceState, VESSEL_DAILY_POSTIONS } from '../mapTypes';

const initialState: TVesselDailyPositionsSliceState = {
    vesselDailyPositionsData: null,
    vesselDailyPositionsLoading: false,
    vesselDailyPositionsError: null,
};

const vesselDailyPositionsSlice = createSlice({
    name: VESSEL_DAILY_POSTIONS,
    initialState,
    reducers: {
        emptyVesselDailyPositionsAction: (state: TVesselDailyPositionsSliceState) => {
            state.vesselDailyPositionsData = null;
            state.vesselDailyPositionsLoading = false;
            state.vesselDailyPositionsError = null;
        },
        getVesselDailyPositionsRequestAction: (state: TVesselDailyPositionsSliceState, _: PayloadAction<{ imoNumbers: number[], date: string }>) => {
            state.vesselDailyPositionsLoading = true;
            state.vesselDailyPositionsError = null;
        },
        getVesselDailyPositionsSuccessAction: (
            state: TVesselDailyPositionsSliceState,
            { payload: data }: PayloadAction<TVesselInfo>,
        ) => {
            state.vesselDailyPositionsLoading = false;
            state.vesselDailyPositionsData = data;
            state.vesselDailyPositionsError = null;
        },
        getVesselDailyPositionsErrorAction: (
            state: TVesselDailyPositionsSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            state.vesselDailyPositionsData = null;
            state.vesselDailyPositionsLoading = false;
            state.vesselDailyPositionsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const {
    emptyVesselDailyPositionsAction,
    getVesselDailyPositionsRequestAction,
    getVesselDailyPositionsSuccessAction,
    getVesselDailyPositionsErrorAction
} =
vesselDailyPositionsSlice.actions;
export default vesselDailyPositionsSlice.reducer;
